import { get, post, del } from "@/libs/http";
import { InfoReq, InfoRes } from "@/types/api/user/info.d";
import { UserBaseInfoRes } from "@/types/api/user/user-base-info.d";
import { UserBaseInfoUpdateReq, UserBaseInfoUpdateRes } from "@/types/api/user/user-base-info-update.d";
import { UserBaseInfoResetReq, UserBaseInfoResetRes } from "@/types/api/user/user-base-info-reset.d";
import { SystemSettingsReq, SystemSettingsRes } from "@/types/api/user/system-settings.d";
import { SystemSettingsSetReq, SystemSettingsSetRes } from "@/types/api/user/system-settings-set.d";
import { AvatarListRes } from "@/types/api/user/avatar-list.d";
import { WithdrawalBankCardReq, WithdrawalBankCardRes } from "@/types/api/user/withdrawal-bank-card.d";
import { WithdrawalBankCardBindReq, WithdrawalBankCardBindRes } from "@/types/api/user/withdrawal-bank-card-bind.d";
import { WithdrawalWeb3WalletReq, WithdrawalWeb3WalletRes } from "@/types/api/user/withdrawal-web3-wallet.d";
import { WithdrawalWeb3WalletBindReq, WithdrawalWeb3WalletBindRes } from "@/types/api/user/withdrawal-web3-wallet-bind.d";
import { WithdrawalWalletIdWeb3WalletDelReq, WithdrawalWalletIdWeb3WalletDelRes } from "@/types/api/user/withdrawal-wallet-id-web3-wallet-del.d";
import { RecordBettingReq, RecordBettingRes } from "@/types/api/user/record-betting.d";
import { RecordBonusReq, RecordBonusRes } from "@/types/api/user/record-bonus.d";
import { RecordCashbackReq, RecordCashbackRes } from "@/types/api/user/record-cashback.d";
import { RecordRechargeReq, RecordRechargeRes } from "@/types/api/user/record-recharge.d";
import { RecordWithdrawalReq, RecordWithdrawalRes } from "@/types/api/user/record-withdrawal.d";
import { VerifyCodeReq, VerifyCodeRes } from "@/types/api/user-auth/verify-code.d";
import { createApiMutationHook } from "@/hooks/use-api-mutation";
import { createApiQuery } from "@/hooks/use-api-query";
import type { UserWithdrawalSendCodeReq, UserWithdrawalSendCodeRes } from "@/types/api/user/user-withdrawal-send-code";

// 获取用户信息
export const getUserInfo = ({ params }: { params: InfoReq; }) => {
  return get<InfoRes>('/user/v1/info', { params });
};

// 获取用户基础信息
export const getUserBaseInfo = () => {
  return get<UserBaseInfoRes>(`/user/v1/userBaseInfo`);
};

// 更新用户基础信息
export const updateUserBaseInfo = ({ params }: { params: UserBaseInfoUpdateReq; }) => {
  return post<UserBaseInfoUpdateRes>('/user/v1/userBaseInfo/update', params);
};

// 重置密码
export const resetUserPassword = ({ params }: { params: UserBaseInfoResetReq; }) => {
  return post<UserBaseInfoResetRes>('/user/v1/userBaseInfo/reset', params);
};

// 验证码检查
export const authVerifyCode = ({ params }: { params: VerifyCodeReq; }) => {
  return post<VerifyCodeRes>('/user/auth/v1/verifyCode', params);
};

// 获取用户系统设置
export const getUserSystemSettings = ({ params }: { params: SystemSettingsReq; }) => {
  return get<SystemSettingsRes>('/user/v1/systemSettings', { params });
};

// 设置用户系统设置
export const setUserSystemSettings = ({ params }: { params: SystemSettingsSetReq; }) => {
  return post<SystemSettingsSetRes>('/user/v1/systemSettings/set', params);
};

// 获取用户头像列表
export const getUserAvatarList = () => {
  return get<AvatarListRes>(`/user/v1/avatarList`);
};

// 获取用户银行卡提现方式
export const getUserWithdrawalBankCard = ({ params }: { params: WithdrawalBankCardReq; }) => {
  return get<WithdrawalBankCardRes>('/user/v1/withdrawal/bankCard', { params });
};

// 绑定用户银行卡提现方式
export const bindUserWithdrawalBankCard = ({ params }: { params: WithdrawalBankCardBindReq; }) => {
  return post<WithdrawalBankCardBindRes>('/user/v1/withdrawal/bankCard/bind', params);
};

// 获取用户web3钱包提现方式
export const getUserWithdrawalWeb3Wallet = ({ params }: { params: WithdrawalWeb3WalletReq; }) => {
  return get<WithdrawalWeb3WalletRes>('/user/v1/withdrawal/web3Wallet', { params });
};

// 绑定用户web3钱包提现方式
export const bindUserWithdrawalWeb3Wallet = ({ params }: { params: WithdrawalWeb3WalletBindReq; }) => {
  return post<WithdrawalWeb3WalletBindRes>('/user/v1/withdrawal/web3Wallet/bind', params);
};

// 删除用户的web3钱包提现方式
export const deleteUserWithdrawalWeb3Wallet = ({ params }: { params: WithdrawalWalletIdWeb3WalletDelReq; }) => {
  return del<WithdrawalWalletIdWeb3WalletDelRes>(`/user/v1/withdrawal/${params.wallet_id}/web3Wallet/del`);
};

// 获取投注记录
export const getUserRecordBetting = ({ params }: { params: RecordBettingReq; }) => {
  return get<RecordBettingRes>('/user/v1/record/betting', { params });
};

// 获取Bonus记录
export const getUserRecordBonus = ({ params }: { params: RecordBonusReq; }) => {
  return get<RecordBonusRes>('/user/v1/record/bonus', { params });
};

// 获取CashBack记录
export const getUserRecordCashback = ({ params }: { params: RecordCashbackReq; }) => {
  return get<RecordCashbackRes>('/user/v1/record/cashback', { params });
};

// 获取充值记录
export const getUserRecordRecharge = ({ params }: { params: RecordRechargeReq; }) => {
  return get<RecordRechargeRes>('/user/v1/record/wallet', { params });
};

// 获取提现记录
export const getUserRecordWithdrawal = ({ params }: { params: RecordWithdrawalReq; }) => {
  return get<RecordWithdrawalRes>('/user/v1/record/withdrawal', { params });
};
// 绑定银行卡-发送验证码
export const withdrawalSendCode = ({ params }: { params: UserWithdrawalSendCodeReq; }) => {
  return post<UserWithdrawalSendCodeRes>('/user/v1/user/withdrawal/sendCode', params);
};
// ================ Hooks ================

// 获取用户信息的 Hook
export const useGetUserInfo = createApiQuery(getUserInfo, () => ['user-info']);

// 获取用户基础信息的 Hook
export const useGetUserBaseInfo = createApiQuery(getUserBaseInfo, () => ['user-base-info']);

// 更新用户基础信息的 Hook
export const useUpdateUserBaseInfo = createApiMutationHook(updateUserBaseInfo);

// 重置密码的 Hook
export const useResetUserPassword = createApiMutationHook(resetUserPassword);

// 验证码检查的 Hook
export const useAuthVerifyCode = createApiMutationHook(authVerifyCode);

// 获取用户系统设置的 Hook
export const useGetUserSystemSettings = createApiQuery(getUserSystemSettings, () => ['user-system-settings']);

// 设置用户系统设置的 Hook
export const useSetUserSystemSettings = createApiMutationHook(setUserSystemSettings);

// 获取用户头像列表的 Hook
export const useGetUserAvatarList = createApiQuery(getUserAvatarList, () => ['user-avatar-list']);

// 获取用户银行卡提现方式的 Hook
export const useGetUserWithdrawalBankCard = createApiQuery(getUserWithdrawalBankCard, () => ['user-withdrawal-bank-card']);

// 绑定用户银行卡提现方式的 Hook
export const useBindUserWithdrawalBankCard = createApiMutationHook(bindUserWithdrawalBankCard);

// 获取用户web3钱包提现方式的 Hook
export const useGetUserWithdrawalWeb3Wallet = createApiQuery(getUserWithdrawalWeb3Wallet, () => ['user-withdrawal-web3-wallet']);

// 绑定用户web3钱包提现方式的 Hook
export const useBindUserWithdrawalWeb3Wallet = createApiMutationHook(bindUserWithdrawalWeb3Wallet);

// 删除用户的web3钱包提现方式的 Hook
export const useDeleteUserWithdrawalWeb3Wallet = createApiMutationHook(deleteUserWithdrawalWeb3Wallet);

// 获取投注记录的 Hook
export const useGetUserRecordBetting = createApiQuery(getUserRecordBetting, (params) => ['user-record-betting', params.params.category]);

// 获取Bonus记录的 Hook
export const useGetUserRecordBonus = createApiQuery(getUserRecordBonus, () => ['user-record-bonus']);

// 获取CashBack记录的 Hook
export const useGetUserRecordCashback = createApiQuery(getUserRecordCashback, () => ['user-record-cashback']);

// 获取充值记录的 Hook
export const useGetUserRecordRecharge = createApiQuery(getUserRecordRecharge, () => ['user-record-recharge']);

// 获取提现记录的 Hook
export const useGetUserRecordWithdrawal = createApiQuery(getUserRecordWithdrawal, () => ['user-record-withdrawal']);

// 绑定银行卡-发送验证码的 Hook
export const useWithdrawalSendCode = createApiMutationHook(withdrawalSendCode);



// 二次确认
export const withdrawalDoubleCheck = ({ params }: { params: { account: string; checkType: 1 | 2; network?: string; }; }) => {
  return post<{ canBind: boolean; }>('/user/v1/user/withdrawal/doubleCheck', params);
};
// 二次确认的 Hook
export const useWithdrawalDoubleCheck = createApiMutationHook(withdrawalDoubleCheck);
